export default __webpack_public_path__ + "static/media/08_photo.cc970b2f.jpg";